import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Page Size',
	PageOrientation: 'Page Orientation',
	Format: 'Format',
	DPI: 'DPI',
	Generate: 'Generate',
	LanguageName: 'English',
	LanguageCode: 'en'
};

export default translation;
